// extracted by mini-css-extract-plugin
export default {"InfoIcon":"InfoIcon-module-ec3bfb3e86eb88ae0aaa"};